const VIDEO_ID = /^[A-Za-z0-9_-]{11}$/
const YOUTUBE_HOSTS = new Set([
  'youtube.com',
  'www.youtube.com',
  'm.youtube.com',
  'music.youtube.com',
  'youtube-nocookie.com',
  'www.youtube-nocookie.com',
])

// Work samples contain both legacy video IDs and URLs entered in Profile Manager.
export function getYouTubeVideoId(value) {
  if (typeof value !== 'string') return null
  const input = value.trim()
  if (VIDEO_ID.test(input)) return input

  // Older settings stripped the host but kept share parameters or path prefixes.
  const legacy = input.match(
    /^(?:\/?(?:embed|shorts|live)\/)?([A-Za-z0-9_-]{11})(?:[?&#].*)?\/?$/,
  )
  if (legacy) return legacy[1]

  try {
    const url = new URL(
      /^[a-z][a-z\d+.-]*:/i.test(input) ? input : `https://${input}`,
    )
    if (!['https:', 'http:'].includes(url.protocol)) return null
    const host = url.hostname.toLowerCase()
    let id
    if (host === 'youtu.be' || host === 'www.youtu.be') {
      id = url.pathname.split('/')[1]
    } else if (YOUTUBE_HOSTS.has(host)) {
      if (url.pathname === '/watch' || url.pathname === '/live') {
        id = url.searchParams.get('v')
      } else {
        const match = url.pathname.match(
          /^\/(?:embed|shorts|live)\/([^/]+)\/?$/,
        )
        id = match?.[1]
      }
    }
    return id && VIDEO_ID.test(id) ? id : null
  } catch {
    return null
  }
}
